import React from 'react';
import './Brands.css';

/** Inline SVG monogram marks — no external logo images */
const BrandMark = ({ children, viewBox = '0 0 48 48' }) => (
  <svg className="brand-logo" viewBox={viewBox} aria-hidden="true" focusable="false">
    {children}
  </svg>
);

const brands = [
  {
    name: 'Ford',
    mark: (
      <BrandMark>
        <ellipse cx="24" cy="24" rx="20" ry="12" fill="none" stroke="currentColor" strokeWidth="2.5" />
        <text x="24" y="28" textAnchor="middle" fontSize="11" fontWeight="800" fontFamily="system-ui,sans-serif" fill="currentColor">FORD</text>
      </BrandMark>
    ),
  },
  {
    name: 'Toyota',
    mark: (
      <BrandMark>
        <ellipse cx="24" cy="24" rx="18" ry="18" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <ellipse cx="24" cy="24" rx="8" ry="18" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <ellipse cx="24" cy="24" rx="18" ry="7" fill="none" stroke="currentColor" strokeWidth="2.2" />
      </BrandMark>
    ),
  },
  {
    name: 'Honda',
    mark: (
      <BrandMark>
        <text x="24" y="31" textAnchor="middle" fontSize="26" fontWeight="800" fontFamily="system-ui,sans-serif" fill="currentColor">H</text>
      </BrandMark>
    ),
  },
  {
    name: 'Chevrolet',
    mark: (
      <BrandMark>
        <path d="M24 6 L38 24 L24 42 L10 24 Z" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" />
        <path d="M18 24 H30 M24 18 V30" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </BrandMark>
    ),
  },
  {
    name: 'BMW',
    mark: (
      <BrandMark>
        <circle cx="24" cy="24" r="17" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <path d="M24 7 A17 17 0 0 1 41 24 L24 24 Z" fill="currentColor" opacity="0.9" />
        <path d="M24 41 A17 17 0 0 1 7 24 L24 24 Z" fill="currentColor" opacity="0.9" />
        <circle cx="24" cy="24" r="17" fill="none" stroke="currentColor" strokeWidth="2.2" />
      </BrandMark>
    ),
  },
  {
    name: 'Mercedes',
    mark: (
      <BrandMark>
        <circle cx="24" cy="24" r="17" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <path d="M24 9 L24 24 M24 24 L12 34 M24 24 L36 34" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </BrandMark>
    ),
  },
  {
    name: 'Audi',
    mark: (
      <BrandMark viewBox="0 0 64 32">
        <circle cx="14" cy="16" r="9" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <circle cx="28" cy="16" r="9" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <circle cx="42" cy="16" r="9" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <circle cx="56" cy="16" r="9" fill="none" stroke="currentColor" strokeWidth="2.2" />
      </BrandMark>
    ),
  },
  {
    name: 'Nissan',
    mark: (
      <BrandMark>
        <circle cx="24" cy="24" r="17" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <ellipse cx="24" cy="24" rx="17" ry="6" fill="none" stroke="currentColor" strokeWidth="2" />
        <text x="24" y="28" textAnchor="middle" fontSize="9" fontWeight="800" fontFamily="system-ui,sans-serif" fill="currentColor">NISSAN</text>
      </BrandMark>
    ),
  },
  {
    name: 'Hyundai',
    mark: (
      <BrandMark>
        <ellipse cx="24" cy="24" rx="18" ry="14" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <path d="M14 24 Q24 14 34 24 Q24 34 14 24" fill="none" stroke="currentColor" strokeWidth="2.2" />
      </BrandMark>
    ),
  },
  {
    name: 'Kia',
    mark: (
      <BrandMark>
        <text x="24" y="30" textAnchor="middle" fontSize="18" fontWeight="800" fontFamily="system-ui,sans-serif" letterSpacing="1" fill="currentColor">KIA</text>
      </BrandMark>
    ),
  },
  {
    name: 'Dodge',
    mark: (
      <BrandMark>
        <path d="M8 30 L24 10 L40 30 Z" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round" />
        <path d="M16 30 H32" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </BrandMark>
    ),
  },
  {
    name: 'Jeep',
    mark: (
      <BrandMark>
        <text x="24" y="30" textAnchor="middle" fontSize="16" fontWeight="800" fontFamily="system-ui,sans-serif" letterSpacing="2" fill="currentColor">JEEP</text>
      </BrandMark>
    ),
  },
  {
    name: 'Volkswagen',
    mark: (
      <BrandMark>
        <circle cx="24" cy="24" r="17" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <path d="M15 16 L24 34 L33 16 M19 16 H29" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </BrandMark>
    ),
  },
  {
    name: 'Subaru',
    mark: (
      <BrandMark>
        <circle cx="24" cy="24" r="17" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <path d="M24 12 L27 20 H35 L28.5 25 L31 34 L24 28.5 L17 34 L19.5 25 L13 20 H21 Z" fill="currentColor" />
      </BrandMark>
    ),
  },
  {
    name: 'Lexus',
    mark: (
      <BrandMark>
        <ellipse cx="24" cy="24" rx="16" ry="18" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <path d="M24 10 V30 M24 30 L14 22" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </BrandMark>
    ),
  },
  {
    name: 'Acura',
    mark: (
      <BrandMark>
        <path d="M24 8 L38 40 H10 Z" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        <path d="M24 18 V34" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </BrandMark>
    ),
  },
];

const Brands = () => {
  return (
    <section className="brands" id="brands">
      <div className="brands-container">
        <div className="brands-header">
          <div className="section-badge light">ALL MAJOR BRANDS</div>
          <h2>We Supply Parts For All<br />Major Car Brands</h2>
          <p>From domestic to import, economy to luxury — we&apos;ve got parts for every make and model.</p>
        </div>

        <div className="brands-grid">
          {brands.map((b) => (
            <div className="brand-item" key={b.name}>
              <div className="brand-logo-wrapper" aria-hidden="true">
                {b.mark}
              </div>
              <span className="brand-name">{b.name}</span>
            </div>
          ))}
        </div>

        <div className="brands-note">
          <span>Don&apos;t see your brand?</span>
          <a href="#contact">Contact us — we source parts for ALL vehicles</a>
        </div>
      </div>
    </section>
  );
};

export default Brands;
